enum MASK_VARIABLES {
  CIRCLE_SCALE = '--circleScale',
  TEXT_MASK_X = '--textMaskX',
  TEXT_MASK_Y = '--textMaskY',
}

import { useMaskCircle } from 'animations/MaskCircle';

export { useMaskCircle as default, MASK_VARIABLES };
